import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/engagement.css";

const ITEMS_PER_PAGE = 9;
const MIN_PAGES = 5;

const blogs = [
    // ✅ NEW BLOG ALWAYS FIRST
  { id: 5, image: "/assets/b_5.png", title: "Work-Life Balance Examples to Boost Employee Engagement", path: "/worklife-balance" },
  { id: 4, image: "/assets/b_4.png", title: "The Heart of Modern Workplaces HR Voices by Outstanding Workplaces", path: "/modern-workplaces" },
  { id: 1, image: "/assets/b_1.png", title: "Boost employee engagement with recognition programs, open communication, and growth opportunities to create a thriving, outstanding workplace culture.”",path: "/employee-engagement" },
  { id: 2, image: "/assets/b_2.png", title: "Employee Wellbeing – Prioritize physical, mental, and emotional health.",path: "/employee-well" },
  { id: 3, image: "/assets/b_3.png", title: "Inclusive Culture – Promote diversity and ensure every voice is valued.",path: "/promote-tech" },
];

const categories = [
  { label: "All Blogs", path: "/blogs" },
  { label: "Workplace Best Practices", path: "/work" },
  { label: "Employee Engagement", path: "/Engagement" },
  { label: "Employee Branding", path: "/Brand" },
  { label: "Thought Leadership & Workplace Culture", path: "/Thought" },
];

const getPageWindow = (current, total) => {
  const windowSize = 1;
  let start = Math.max(1, current - Math.floor(windowSize / 2));
  let end = start + windowSize - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - windowSize + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

const CustomDropdown = ({ selected, setSelected, onNavigate }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="engagement-dropdown">
      <div className="engagement-dropdown__header" onClick={() => setOpen(!open)}>
        <span>{selected}</span>
        <span className={`engagement-dropdown__arrow ${open ? "open" : ""}`}>
          <img src="/assets/arrow_1.png" alt="arrow" />
        </span>
      </div>

      {open && (
        <div className="engagement-dropdown__list">
          {categories.map((item, index) => (
            <div
              key={index}
              className="engagement-dropdown__item"
              onClick={() => {
                setSelected(item.label);
                setOpen(false);
                onNavigate(item.path);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const BlogPage = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("Employee Engagement");
  const [currentPage, setCurrentPage] = useState(1);

  const realTotalPages = Math.ceil(blogs.length / ITEMS_PER_PAGE);
  const totalPages = Math.max(realTotalPages, MIN_PAGES);

  const handlePageChange = (n) => {
    if (n < 1 || n > totalPages) return;
    setCurrentPage(n);
  };

  const pageBlogs = blogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const pageWindow = getPageWindow(currentPage, totalPages);

  return (
    <div className="engagement">
      {/* HEADER */}
      <div className="engagement__header">
        <h2 className="engagement__title-main">Employee Engagement</h2>
        <CustomDropdown
          selected={selectedCategory}
          setSelected={(label) => {
            setSelectedCategory(label);
            setCurrentPage(1);
          }}
          onNavigate={(path) => navigate(path)}
        />
      </div>

      {/* GRID */}
      <div className="engagement__grid">
        {pageBlogs.length > 0 ? (
          pageBlogs.map((blog) => (
  <div
    className="engagement-card"
    key={blog.id}
    onClick={() => blog.path && navigate(blog.path)}
  >
    <div className="engagement-card__image-wrapper">
      <img src={blog.image} alt="" className="engagement-card__image" />
    </div>

    <p className="engagement-card__title">{blog.title}</p>
  </div>
))
        ) : (
          <p className="engagement__no-results">No blogs found.</p>
        )}
      </div>

      {/* PAGINATION */}
      <div className="engagement-pagination">
        <button
          className="engagement-pagination__btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ← Previous
        </button>

        <div className="engagement-pagination__numbers">
          {pageWindow.map((n) => {
            const isDisabled = n > realTotalPages;
            return (
              <span
                key={n}
                className={`engagement-pagination__number 
                  ${n === currentPage ? "engagement-pagination__number--active" : ""}
                  ${isDisabled ? "engagement-pagination__number--disabled" : ""}
                `}
                onClick={() => !isDisabled && handlePageChange(n)}
              >
                {n}
              </span>
            );
          })}
        </div>

        <button
          className="engagement-pagination__btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === realTotalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default BlogPage;